module.exports = __webpack_public_path__ + "img/add-card-about-2.79c35af2.png";